import {
    formatPurchaseOrderDate,
    formatPurchaseOrderDateTime,
} from 'components/procurement/components/purchaseOrdersV2/utils/purchaseOrderDateUtils';
import {
    FALLBACK_TEXT,
    normalizeOptionalText,
} from 'components/procurement/components/purchaseOrdersV2/utils/purchaseOrderDisplayUtils';

import { FREIGHT_TYPE_OPTIONS } from './crossDockPurchaseOrderCreateValidation';

export const CROSS_DOCK_PURCHASE_ORDERS_LIST_PATH = '/logistics/cross-dock-purchase-orders';

export function getCrossDockPurchaseOrderViewPath(id) {
    return `/logistics/view-cross-dock-purchase-order/${id}`;
}

export function parseCrossDockPurchaseOrderId(id) {
    if (id === null || id === undefined || id === '') {
        return null;
    }
    const normalized = String(id).trim();
    if (!/^\d+$/.test(normalized)) {
        return null;
    }
    const parsed = Number.parseInt(normalized, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function formatCrossDockPurchaseOrderFreightType(freightType) {
    const match = FREIGHT_TYPE_OPTIONS.find((option) => option.value === freightType);
    return match?.label ?? normalizeOptionalText(freightType);
}

export function formatCrossDockPurchaseOrderScheduledDelivery(order) {
    const date = formatPurchaseOrderDate(order?.scheduledDeliveryDate, '');
    const time = order?.scheduledDeliveryTime;
    if (date && time) {
        return `${date} ${time}`;
    }
    return date || time || FALLBACK_TEXT;
}

export function formatCrossDockPurchaseOrderPoMapLabel(poMap) {
    if (poMap?.purchaseOrderId != null) {
        return String(poMap.purchaseOrderId);
    }
    if (poMap?.packagingPurchaseOrderId != null) {
        return `PPO-${poMap.packagingPurchaseOrderId}`;
    }
    return FALLBACK_TEXT;
}

export function getCrossDockPurchaseOrderPoMapHref(poMap) {
    if (poMap?.purchaseOrderId != null) {
        return `/procurement/viewPurchaseOrder-v2/${poMap.purchaseOrderId}`;
    }
    if (poMap?.packagingPurchaseOrderId != null) {
        return `/packaging/viewPurchaseOrder-v2/${poMap.packagingPurchaseOrderId}`;
    }
    return null;
}

export function formatCrossDockPurchaseOrderCreatedOn(createdAt) {
    return formatPurchaseOrderDateTime(createdAt, FALLBACK_TEXT);
}
